import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InputLabel from "@material-ui/core/InputLabel";
import { DatePicker } from "@material-ui/pickers";
import KpsEditor from "../editor/KpsEditor";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import { HOT_TOPIC_ADD, HOT_TOPIC_UPDATE } from "../../utils/Topics";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import UserTeamPicker from "../required-reading/UserTeamPicker";
import { stompClientsContainer} from "../../UniversalElement";
import ActionButton from "../ActionButton";
import KpsTextField from "../KpsTextField";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
import { connect } from "react-redux";

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  expiryDate: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
  },
  inputLabel: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  summary: {
    display: "flex",
    flexDirection: "column",
  },
});

export class CreateMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: "",
      title: "",
      expiryDate: null,
      instance: new Date().getTime().toString(),
      attachmentIds: [],
      activeStep: 0,
      users: [],
      teamUsers: [],
      initialDetail: "",
      notificationId: null,
      saving: false,
      loadingUsers: false,
      titleTouched: false,
      expiryDateTouched: false,
    };
  }

  static propTypes = {
    prop: PropTypes,
  };

  componentDidMount() {
    if (this.props.isEdit) {
      this.setState({
        initialDetail: this.props.hotTopic.content,
        title: this.props.hotTopic.title,
        expiryDate: this.props.hotTopic.expiryDate,
        users: this.props.hotTopic.users,
        teamUsers: this.props.hotTopic.teamUsers,
        notificationId: this.props.hotTopic.notificationId,
      });
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          onClose={this.props.onClose}
          open={this.props.open}
          fullWidth
          disableEnforceFocus={true}
        >
          <DialogTitle>
            <Trans
              i18nKey={
                this.props.isEdit ? "edit_message" : "create_new_message"
              }
            />
            <IconButton
              aria-label="Close"
              className={classes.closeButton}
              onClick={this.props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={this.state.activeStep}>
              <Step>
                <StepLabel>
                  <Trans
                    i18nKey={
                      this.props.isEdit
                        ? "edit_message"
                        : "drawer_create_message"
                    }
                  />
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Trans i18nKey="create_message_stepper_select_users" />
                </StepLabel>
              </Step>
            </Stepper>
            {this.state.activeStep === 0 && (
              <>
                <div className={classes.summary}>
                  <KpsTextField
                    id="message-title"
                    label={this.props.t("message_title")}
                    value={this.state.title}
                    onBlur={() => this.setState({ titleTouched: true })}
                    onChange={this.handleSummaryChange}
                    helperText={
                      this.state.titleTouched && !this.state.title
                        ? this.props.t("global_required")
                        : ""
                    }
                    error={this.state.titleTouched && !this.state.title}
                  />
                </div>
                <div className={classes.inputLabel}>
                  <InputLabel>
                    <Trans i18nKey="message_detail" />
                  </InputLabel>
                </div>
                <KpsEditor
                  initialContent={this.state.initialDetail}
                  simpleToolbar
                  updateUploadArray={this.updateUploadArray}
                  ref="section"
                  newUploadId={this.newUploadId}
                  onChange={this.handleDetailChange}
                />
                <div className={classes.expiryDate}>
                  <DatePicker
                    id="message-expiry"
                    autoOk
                    onOpen={() => this.setState({ expiryDateTouched: true })}
                    label={this.props.t("expiry_date")}
                    clearable
                    disablePast
                    value={this.state.expiryDate}
                    helperText={
                      this.state.expiryDateTouched && !this.state.expiryDate
                        ? this.props.t("global_required")
                        : ""
                    }
                    onChange={this.handleExpiryDateChange}
                    error={
                      this.state.expiryDateTouched && !this.state.expiryDate
                    }
                  />
                </div>
              </>
            )}
            {this.state.activeStep === 1 && (
              <UserTeamPicker
                onUsersUpdate={this.onUsersUpdate}
                onTeamUsersUpdate={this.onTeamUsersUpdate}
                userHeaderKey="create_message_users_header"
                userTeamHeaderKey="create_message_users_team_header"
                loadingUsers={this.loadingUsers}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.onClose}
              color="primary"
              style={{ margin: "0 auto 0 0" }}
            >
              <Trans i18nKey="global_cancel" />
            </Button>

            {this.state.activeStep > 0 && (
              <Button onClick={this.handleBack} color="primary" autoFocus>
                <Trans i18nKey="">
                  <Trans i18nKey="global_back" />
                </Trans>
              </Button>
            )}
            <ActionButton
              loading={this.state.saving || this.state.loadingUsers}
              onClick={this.handleNext}
              disabled={!this.state.expiryDate}
              color="primary"
              autoFocus
            >
              {this.state.activeStep === 0 ? (
                <Trans
                  i18nKey={this.props.isEdit ? "global_update" : "global_next"}
                />
              ) : (
                <Trans i18nKey="global_send" />
              )}
            </ActionButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  loadingUsers = (e) => {
    this.setState({ loadingUsers: e });
  };

  onUsersUpdate = (users) => {
    this.setState({ users });
  };

  onTeamUsersUpdate = (teamUsers) => {
    this.setState({ teamUsers });
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleNext = () => {
    if (this.props.isEdit) {
      this.updateMessage();
    } else {
      if (this.state.activeStep < 1) {
        this.setState({
          activeStep: this.state.activeStep + 1,
          initialDetail: this.state.detail,
        });
      } else {
        this.sendMessage();
      }
    }
  };

  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({ attachmentIds: attachments });
  };
  handleSummaryChange = (e) => {
    this.setState({ title: e.target.value, titleTouched: true });
  };

  handleDetailChange = (e) => {
    this.setState({ detail: e });
  };

  handleExpiryDateChange = (e) => {
    this.setState({ expiryDate: e, expiryDateTouched: true });
  };

  updateMessage = () => {
    stompClientsContainer.notificationservice.publish({
      destination: "/app/message/edit",
      body: JSON.stringify({
        users: this.state.users,
        title: this.state.title,
        content: this.state.detail,
        expiryDate: this.state.expiryDate,
        notificationId: this.state.notificationId,
        attachmentIds: this.state.attachmentIds,
      }),
    });
    this.props.onClose();
  };

  sendMessage = () => {
    if (containsScriptOrSVG([this.state.detail])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.detail])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    this.setState({ saving: true });
    axios
      .post("/hottopic/", {
        summary: this.state.title,
        detail: this.state.detail,
        expiryDate: this.state.expiryDate,
        attachmentIds: this.state.attachmentIds,
        users: this.state.users
          .map((e) => {
            return e.userId;
          })
          .concat(this.state.teamUsers),
      })
      .then((res) => {
        this.setState({ saving: false });
        this.props.onClose();
        PubSub.publish(HOT_TOPIC_ADD, {});
      })
      .catch(() => this.setState({ saving: false }));
  };
}
const mapDispatchToProps = {
  setGlobalAlert,
};
export default    connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CreateMessage)));
